import {AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, ViewChild } from "@angular/core";

declare const AlgebraKIT;

@Component({
    selector: "app-akit-matharea",
    templateUrl: "./akit-matharea.component.html",
    styleUrls: ["./akit-matharea.component.less"],
    standalone: false
})
export class AkitMathAreaComponent implements AfterViewInit, OnInit, OnChanges {

    @ViewChild("editor") wrapper: ElementRef;
    @Input() _i18n: string = "['en']";
    @Input() palette: string = "equations";

    @Output() contentChanged: EventEmitter<string> = new EventEmitter<string>();
    
    renderPromise: Promise<void>;
    renderResolve: () => void; //to resolve promise after render

    constructor(
        private _ngZone: NgZone
    ) {}

    getEditorHTML():string {
        return `<akit-matharea palette="${this.palette}" i18n="${this._i18n}" variables="['x','y']"></akit-matharea>`;
    }
    ngOnInit(): void {
    }
 
    ngAfterViewInit(): void {
        this.rehydrate();
    }

    ngOnChanges() {
        this.rehydrate();
    }

    rehydrate() {
        if(this.wrapper && this.wrapper.nativeElement) {
            this.wrapper.nativeElement.innerHTML=this.getEditorHTML();

            let tags:HTMLCollectionOf<Element> = document.getElementsByTagName('akit-matharea');
            if(tags && tags.length>0) {
                let mathAreaElement = tags[0];
                let self = this;

                this._ngZone.runOutsideAngular(() => {
                    AlgebraKIT.waitUntilReady(mathAreaElement).then(() => {
                        mathAreaElement.addEventListener('contentChange', (event:any) => {
                            self._ngZone.run(() => {
                                self.contentChanged.emit(event.detail);
                            })
                        });

                        // applies when the formula editor is used in detached mode
                        // formulaEditor.setExternalMathquillEditor(mathQuillEditor);
    
    
                        //other functionality:
                        //- formulaEditor.setLatex('x^2');
                        //- formulaEditor.addChangeListener(function...)
                        //- formulaEditor.removeChangeListener(function...)
                        //- formulaEditor.focusEditor()
    
                    });
                })

            }
        }
    }
    
}
